import * as React from 'react';
import { throttle } from 'lodash';
import './index.css';

const LEFT = 0;
const RIGHT = 1;

interface IState {
  showDialog: boolean;
}

interface Props {
  title?: string;
  message?: string;
  // 白色按钮
  leftBtnText?: string;
  // 黄色按钮
  rightBtnText?: string;
  onClickLeftBtn?: () => void;
  onClickRightBtn?: () => void;
  onClickMask?: () => void;
  onClickClose?: () => void;
  messageMaxLines?: number;
  titleMaxLines?: number;
  // topBottom: 按钮为上下按钮 默认为左右按钮
  buttonStyle?: string;
  notModal?: boolean; // 是否在modal中展示
  /** 顶部 warning 图标资源路径；不传时保持原布局 */
  iconSrc?: string;
  /** 弹窗挂载后触发，用于曝光上报 */
  onDialogShow?: () => void;
}

export default class CommonDialog extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showDialog: true,
    };
  }

  componentDidMount() {
    this.props.onDialogShow?.();
  }

  onClickBtn = (btn: number) => {
    if (btn === LEFT) {
      this.props.onClickLeftBtn?.();
    } else if (btn === RIGHT) {
      this.clickRightBtn();
    }
  };

  clickRightBtn = throttle(() => {
    this.props.onClickRightBtn?.();
  }, 1000);

  onCloseDialog = () => {
    if (this.props.onClickMask) {
      this.props.onClickMask?.();
    } else {
      this.props.onClickLeftBtn?.();
    }
  };

  componentWillUnmount() {
    this.clickRightBtn.cancel();
  }

  renderContainer = () => {
    const {
      title,
      message,
      buttonStyle = '',
      leftBtnText,
      rightBtnText,
      messageMaxLines = 3,
      titleMaxLines = 3,
      onClickClose,
      iconSrc
    } = this.props;
    return (
      <view className="dialog-mask" onClick={() => this.onCloseDialog()}>
        <view
          className="dialog-container"
          onClick={() => {
            //do noting 防止点击内容区域弹窗消失
          }}
        >
          {onClickClose ? (
            <view className="dialog-icon-container">
              <view
                className="dialog-icon"
                onClick={onClickClose}
                hitSlop={{
                  top: 5, bottom: 5, left: 5, right: 5
                }}
              >
                <image src="assets://address/dialogClose.png" className="dialog-icon-close" />
              </view>
            </view>
          ) : null}
          {iconSrc ? (
            <view className="dialog-warning-icon-wrap">
              <image className="dialog-warning-icon" src={iconSrc} />
            </view>
          ) : null}
          <view className={iconSrc ? 'dialog-content dialog-content-with-icon' : 'dialog-content'}>
            {title ? <text className="dialog-title" style={{ maxLines: titleMaxLines }} content={title} /> : null}
            {message ? <text className="dialog-message" style={{ maxLines: messageMaxLines }} content={message} /> : null}
          </view>
          {buttonStyle === 'topBottom' ? (
            <view className="dialog-button-container top-bottom">
              {rightBtnText && (
                <text
                  className="dialog-button dialog-button-right"
                  content={rightBtnText}
                  onClick={() => this.onClickBtn(RIGHT)}
                />
              )}
              {leftBtnText && (
                <text className="dialog-button diglog-button-top-bottom" content={leftBtnText} onClick={() => this.onClickBtn(LEFT)} />
              )}
            </view>
          ) : (
            <view className="dialog-button-container">
              {leftBtnText && (
                <text className="dialog-button" content={leftBtnText} onClick={() => this.onClickBtn(LEFT)} />
              )}
              {leftBtnText && rightBtnText ? <view className="gap" /> : null}
              {rightBtnText && (
                <text
                  className="dialog-button dialog-button-right"
                  content={rightBtnText}
                  onClick={() => this.onClickBtn(RIGHT)}
                />
              )}
            </view>
          )}
        </view>
      </view>
    );
  }

  render() {
    const { notModal } = this.props;
    if (notModal) {
      return this.renderContainer();
    }

    return (
      <modal onRequestCloseDialog={() => this.onCloseDialog()}>
        {this.renderContainer()}
      </modal>
    );
  }
}
